import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";
import { signOut } from "firebase/auth";
import { functionsBaseUrl } from "../config/runtime";
import { authenticatedJson } from "../utils/guestSession";

const VerifyPayment = () => {
    const navigate = useNavigate();
    const hasRun = React.useRef(false);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;

        const verifyPayment = async () => {

            const reference =
                new URLSearchParams(window.location.search).get("reference")
                || localStorage.getItem("pendingReference");


            if (!reference) {
                navigate("/");
                return;
            }

            try {
                const pendingData =
                    JSON.parse(localStorage.getItem("pendingOnboarding"));

                if (!pendingData) {
                    alert("No onboarding data found");
                    navigate("/");
                    return;
                }

                const completion = await authenticatedJson(`${functionsBaseUrl}/completeOnboarding`, {
                    reference,
                    selectedPlan: pendingData.selectedPlan,
                    form: pendingData.form,
                });

                await signOut(auth);
                navigate(`/shop-login?success=true${completion.reviewEmailSent ? "" : "&reviewEmail=failed"}`, {
                    replace: true,
                });

                localStorage.removeItem("pendingOnboarding");
                localStorage.removeItem("selectedPlan");
                localStorage.removeItem("pendingReference");

                navigate(`/shop-login?success=true${completion.reviewEmailSent ? "" : "&reviewEmail=failed"}`, { replace: true });

            } catch (error) {
                console.error("Account creation error:", error);

                const errorMessage =
                    error?.response?.data?.message ||   // Cloud Function/API error
                    error?.response?.data?.error ||     // API error
                    error?.message ||                   // Firebase/Axios error
                    "Payment verification failed";

                alert(errorMessage);
                navigate("/onboarding/plan", { replace: true });
            }
        };

        verifyPayment();

    }, [navigate, functionsBaseUrl]);

    return (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50">
            <div className="animate-spin h-14 w-14 border-4 border-black border-t-transparent rounded-full"></div>
            <h2 className="ml-4 text-lg font-medium text-[#212326]">
                Verifying payment...
            </h2>
        </div>
    );
};

export default VerifyPayment;
